//
//
//
//

export default {
	name: 'btn-link',

	props: {
		btn: {
			type: Object,
			required: true
		}
	},

	computed: {
		link: function link() {
			return this.btn.link;
		}
	},

	methods: {
		clickHandle: function clickHandle(e) {
			if (this.btn.prevent) return;

			if (this.replace) {
				this.$router.replace(this.link);
			} else {
				this.$router.push(this.link);
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnLink.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BtnLink.vue
// module chunks = 5